import React from 'react'

import { differenceInCalendarDays, addWeeks, startOfWeek, endOfWeek } from 'date-fns'

import { useSearchVehicleStatsQuery } from '@edge/spark/io-dashboards'
import { CardType } from '@edge/spark/io-dashboards'
import { SingleNumberWidget } from '../../BaseComponents/SingleNumberWidget'
import type { BasicWidgetProps } from '../../types'

const DEFAULT_CARD_HEADER = 'Vehicles'
const DEFAULT_TEXT = 'Registered'
const DEFAULT_SECONDARY_TEXT = 'Next Week'
const DEFAULT_ACTION_TEXT = 'View Vehicles (Presale)'

// NEXT WEEK
const now = new Date()
const nextWeek = addWeeks(now, 1)
const startDays = differenceInCalendarDays(startOfWeek(nextWeek), now)
const endDays = differenceInCalendarDays(endOfWeek(nextWeek), now) + 1

const RegisteredNextWeek: React.FC<BasicWidgetProps> = ({
    config,
    widgetId,
    handleConfig,
    readonly,
}: BasicWidgetProps) => {
    const cardHeaderText = config.title || DEFAULT_CARD_HEADER
    const searchString = `saledate:${startDays}-${endDays}+`
    const actionText = config.linklabel || DEFAULT_ACTION_TEXT
    const actionLink = config.linkurl
        ? `${config.linkurl}?search=${encodeURIComponent(searchString)}`
        : `/searchdetails/customcard/vehicle-presale?search=${encodeURIComponent(searchString)}`
    const widgetText = config.label || DEFAULT_TEXT
    const widgetSecondaryText = config.sublabel || DEFAULT_SECONDARY_TEXT

    const { loading, data } = useSearchVehicleStatsQuery({
        variables: { searchString },
    })

    const vehicleCount = data?.auction?.search?.vehicleStats?.total

    return (
        <SingleNumberWidget
            data-test="registered-next-week-single-number-widget-new"
            cardType={CardType.CUSTOM}
            cardHeaderText={cardHeaderText}
            action={{
                text: actionText,
                link: actionLink,
            }}
            loading={loading}
            number={vehicleCount}
            text={widgetText}
            text2={config.label2}
            secondaryText={widgetSecondaryText}
            widgetId={widgetId}
            handleConfig={handleConfig}
            readonly={readonly}
        />
    )
}

export default RegisteredNextWeek
